import { mutations } from "@/constants/state";

export default {
  [mutations.USERS_ENABLED_FETCH_MUTATION]: (state, payload) => {
    state.enabledUsers = payload;
  },
};
